import { combineReducers } from "redux";
import authReducer from "./auth";
import dashboardReducer from "./dashboard";
import staffReducer from "./staff";
import profileReducer from "./profile";
import reportReducer from "./report";
import supportPlanReducer from "./supportplan";
import ticketReducer from "./ticket";
import documentReducer from "./document";
import notificationReducer from "./notification";
import themeReducer from "./theme";
import billingprovider from "./billingprovider";
import BillingReducer from "./billing";
import PayerReducer from "./payer";
import ServiceCodeReducer from "./servicecode";
import billinginvoiceReducer from "./billinginvoice";
import settinginvoiceReducer from "./settinginvoice";
import featureFlagsReducer from "./split";
import skaiSlice from "./skaiSlice";
import signatureReducer from "./signature";
import skypointProviderReducer from "./skypointProvider";
import skypointProspectReducer from "./skypointProspect";
import skypointProjectReducer from "./skypointProject";
import skypointBillinginvoiceReducer from "./skypointBillinginvoice";
import skypointAlertsReducer from "./skypointAlerts";
import quarterlyReportReducer from "./quarterlyReport";
// import complianceReducer from "./compliance";


const combinedReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  staff: staffReducer,
  profile: profileReducer,
  report: reportReducer,
  supportPlan: supportPlanReducer,
  ticket: ticketReducer,
  document: documentReducer,
  notification: notificationReducer,
  theme: themeReducer,
  billing: BillingReducer,
  payer: PayerReducer,
  servicecode: ServiceCodeReducer,
  billingprovider: billingprovider,
  billinginvoiceReducer: billinginvoiceReducer,
  settinginvoice: settinginvoiceReducer,
  featureFlags: featureFlagsReducer,
  skai: skaiSlice,
  signature: signatureReducer,
  skypointProviders: skypointProviderReducer,
  skypointProspects: skypointProspectReducer,
  skypointProject: skypointProjectReducer,
  skypointBillinginvoiceReducer: skypointBillinginvoiceReducer,
  skypointAlerts: skypointAlertsReducer,
  quarterlyReport: quarterlyReportReducer,
  // compliance: complianceReducer,

});

// Wipe every slice back to its initial state on logout so no previous user's
// data can be read by the next session. Dispatched by `clearSession()`.
const rootReducer = (state, action) => {
  if (action.type === "RESET_STORE") {
    state = undefined;
  }
  return combinedReducer(state, action);
};

export default rootReducer;
